// extracted by mini-css-extract-plugin
export default {"listImageBackgroundColor":"HnfZM","square":"hhH4Z"};